<template>
  <div class="es-elem-form">
    <!--  表单筛选项  -->
    <div v-if="formList.length" class="form-query-wrapper">
      <el-form v-bind="elFormConfig" :model="queryParam" ref="esForm" :rules="rules" @keyup.enter.native="searchQuery">
        <slot name="searchQuery"></slot>
        <span
          :class="!formItem.model && !formItem.type ? 'form-action-buttons' : 'form-item'"
          v-for="(formItem, pIndex) in sortFormList"
          :key="pIndex"
          v-show="!inlineOverToolHidden ? true : !formItem.hidden || visibleMoreTool"
        >
          <template v-if="!formItem.model && !formItem.type" class="table-page-action-buttons">
            <el-button v-if="elFormConfig.inline && inlineOverToolHidden" type="primary" class="import" @click="visibleMoreTool = !visibleMoreTool">
              更多<i class="el-icon-arrow-down" :class="inlineOverToolHidden?'rotate180':'rotate'"></i>
            </el-button>
            <el-button v-if="formSearchAction" type="primary" class="search" @click="searchQuery">查询</el-button>
            <el-button v-if="formResetAction" class="reset" @click="searchReset">重置</el-button>
            <el-button v-if="formExportAction" class="export" @click="exportTable">导出</el-button>
            <!--预留位置-->
            <slot name="button1"></slot>
            <slot name="button2"></slot>
            <slot name="button3"></slot>
            <br v-if="inlineOverToolHidden"/>
          </template>
          <template v-else>
            <el-form-item :label="`${formItem.label+ (formItem.colon? ':':'')}`" :required="formItem.required" :prop="formItem.model">
              <el-input
                v-if="formItem.type === 'input'"
                v-model="queryParam[formItem.model]"
                :clearable="formItem.clearable"
                :placeholder="`请输入${formItem.label}`"
              ></el-input>
              <el-select
                :ref="'select_filter_'+formItem.model"
                :class="'select_filter_'+formItem.model"
                :popper-class="formItem.popperClass"
                v-if="formItem.type === 'select'"
                v-model="queryParam[formItem.model]"
                :remote-method="(query) => selectRemoteMethod(query, formItem)"
                v-loadmore="() => selectLoadMoreList(formItem)"
                :placeholder="`请选择${formItem.label}`"
                :clearable="formItem.clearable"
                reserve-keyword
                filterable
                remote
                @change="(values) => selectChange(values, formItem)"
                @visible-change="(value) => selectVisibleChange(value, formItem)"
                @clear="() => selectClearList(formItem)"
                @blur="() => selectBlurList(formItem)"
              >
                <!--<el-option v-if="!formItem.required && formItem.emptyOption" value="">
                  {{ formItem.allName ? '请选择' : '全部' }}
                </el-option>-->
                <el-option
                  v-for="(select, sIndex) in selectDataList[formItem.model]"
                  :key="sIndex"
                  :label="select[formItem.key]"
                  :value="select[formItem.value]"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="formItem.type === 'cascader'"
                :popper-class="formItem.popperClass"
                :ref="'cascader_'+formItem.model"
                :key="cascaderKey+pIndex"
                v-model="cascader[formItem.model]"
                :options="selectDataList[formItem.model]"
                :clearable="formItem.clearable"
                :show-all-levels="!!!formItem.showLastLevels"
                change-on-select
                @change="(values) => cascaderChange(values, formItem)"
                :props="{
                checkStrictly: true,
                  children: formItem.children||'children',
                  label: formItem.key,
                  value: formItem.value,
                  expandTrigger: 'hover',
                }">
              </el-cascader>
              <template v-if="formItem.type === 'date'">
                <!--日期季度控件-->
                <date-quarter
                  v-if="formItem.renderType === 'quarter'"
                  v-model="date[formItem.model]"
                  :disabled="elFormConfig.disabled"
                  :format="formItem.format || undefined"
                  :value-format="formItem.valueFormat || undefined"
                  :default-time="formItem.defaultTime || undefined"
                  :clearable="formItem.clearable"
                ></date-quarter>
                <el-date-picker
                  v-else
                  :popper-class="formItem.popperClass"
                  v-model="date[formItem.model]"
                  :clearable="formItem.clearable"
                  :value-format="formItem.valueFormat || undefined"
                  :type="formItem.renderType || 'daterange'"
                  :default-time="formItem.defaultTime || undefined"
                  :picker-options="formItem.pickerOptions || undefined"
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </template>
              <el-radio-group
                v-if="formItem.type === 'radio'"
                v-model="queryParam[formItem.model]">
                <el-radio :label="radio.value" v-for="radio in selectDataList[formItem.model]">{{radio.label}}{{radio.value}}</el-radio>
              </el-radio-group>
              <el-checkbox-group
                v-if="formItem.type === 'checkbox'"
                v-model="queryParam[formItem.model]">
                <el-checkbox :label="checkbox.value" v-for="checkbox in selectDataList[formItem.model]">{{checkbox.label}}</el-checkbox>
              </el-checkbox-group>
              <el-switch
                v-if="formItem.type === 'switch'"
                v-model="queryParam[formItem.model]">
              </el-switch>
            </el-form-item>
          </template>
        </span>
      </el-form>
    </div>
      <!--  表格  -->
      <div class="form-table-wrapper">
        <el-table
          ref="esFormTable"
          v-loading="tableLoading"
          v-bind="elTableConfig"
          @selection-change="onRowSelectChange"
        >
          <el-table-column
            v-for="(column, index) in slotColumns"
            v-bind="elTableColumnConfig[index]"
          >
            <template v-if="!elTableColumnConfig[index].type" scope="scope">
              <slot v-if="column.scopedSlots" :name="column.scopedSlots ? column.scopedSlots.customRender : ''" :scope="scope.row"></slot>
              <span v-else>{{scope.row[column.dataIndex]}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="form-table-pagination">
        <el-pagination
          v-bind="elPaginationConfig"
          @size-change="handleTableSizeChange"
          @current-change="handleTablePageChange"
        ></el-pagination>
      </div>
    </div>
</template>

<script>
  import {downFileTimeout, getAction, postAction, getActionTimeout, postActionTimeout} from './manage';
  import { PAGE_CURRENT, PAGE_SIZE, mergeElemProps } from "./elem.props"
  import { mergeEsProps } from "./es.props";
  import {
    getObjProperty,
    processLastChildrens,
    transParmasBypostToGet,
    formatRangeDateByType,
    formatRangeMakeupTime
  } from "./util";
  import DateQuarter from './lib/dateQuarter';
  import './directive/directive.js'

  const SELECT_PAGE_SIZE = 10;
  const FORM_REQUEST_DATA_ITEM = ['select', 'cascader', 'radio', 'checkbox'];

  function getFormTrigger(model) {
    var trigger = 'change';
    var text = '请选择';
    switch (model) {
      case 'input':
        trigger = 'blur';
        text = '请输入';
        break;
    }
    return {text, trigger}
  }

  export default {
    name: 'ListPage',
    components: {
      DateQuarter
    },
    props: {
      // element 配置参数汇总 {form: {},table: {}, pagination: {}}
      elFormProp: {
        type: Object,
        default() {
          return {};
        },
      },
      inlineOverToolHidden: {
        type: Boolean,
        default: false
      },
      inlineControlCount: {
        type: Number,
        default: 4
      },
      // 筛选查询条件
      formList: {
        type: Array,
        default() {
          return [];
        },
      },
      // 表格表头
      columns: {
        type: Array,
        default() {
          return [];
        },
      },
      formSearchAction: {
        type: Boolean,
        default: true
      },
      formExportAction: {
        type: Boolean,
        default: false
      },
      formMoreAction: {
        type: Boolean,
        default: false
      },
      formSortAction: {
        type: Boolean,
        default: false
      },
      formResetAction: {
        type: Boolean,
        default: false
      },
      formUploadAction: {
        type: Boolean,
        default: false
      },

      // 额外查询条件
      additionQuery: {
        type: Object,
        default() {
          return {};
        },
      },
      tableApi: {
        type: Object,
        default() {
          return {};
        },
      },
      exportApi: {
        type: Object,
        default() {
          return {
            url: '',
          };
        },
      },
      uploadApi: {
        type: Object,
        default() {
          return {
            url: '',
          };
        },
      },
      handleQueryParam: {
        type: Function,
      },
      handleResetPage: {
        type: Function,
      },
      handleLoadPage: {
        type: Boolean,
        default: false,
      },
      prepareHandleParam: {
        type: Function,
      },
      prepareHandleSource: {
        type: Function,
      },
    },
    data() {
      return {
        elFormConfig: mergeElemProps('Form', this.elFormProp.form || {}),
        elTableConfig: mergeElemProps('Table', this.elFormProp.table || {}),
        elPaginationConfig: mergeElemProps('Pagination', this.elFormProp.pagination || {}),
        elTableColumnConfig: mergeElemProps('Table-column', this.columns),
        /*esvue-form*/
        rules: {},
        esTableApi: mergeEsProps('table-api', this.tableApi),
        visibleMoreTool: false,
        queryParam: this.tableApi.query,
        cascaderKey: 0,
        tableLoading: false,

        currentRow: '',
        selectedRows: [],
        selectDataList: {},         //存放表单控件数据源
        selectRequestFormList: [],  //存放需要请求的表单控件
        date: {},
        cascader: {},
        selectPagination: {}  //用于存在下拉框分页数据以及配置
      };
    },
    computed: {
      slotColumns() {
        return this.columns;
      },
      requiredFormList() {
        return this.formList.filter(v => v.required);
      },
      selectFormList() {
        return this.formList.filter((form) => FORM_REQUEST_DATA_ITEM.includes(form.type));
      },
      dateFormList() {
        return this.formList.filter((form) => form.type === 'date');
      },
      // 真实渲染formList
      sortFormList() {
        const temp = JSON.parse(JSON.stringify(this.formList));
        let overMore = false;
        if(this.elFormConfig.inline && this.inlineOverToolHidden){
          if (this.formList.length > this.inlineControlCount) {
            overMore = true;
            temp.splice(this.inlineControlCount, 0, {});
            temp.forEach((v, i) => {
              if (i > this.inlineControlCount) {
                v.hidden = true;
              }
            })
          }
        }
        if(!overMore){
          temp.push({});
        }
        return temp
      },
    },
    created() {
      this.initFormRule();
      this.initQueryParam();
      this.watchDateChange();
      this.watchSelectStoreChange();
      this.watchSelectRequestChange();
      !this.handleLoadPage && this._getDataList();
    },
    methods: {
      // 初始化表单必填项校验
      initFormRule() {
        this.requiredFormList.forEach(formItem => {
          var triggleType = getFormTrigger(formItem.type);
          this.$set(this.rules, formItem.model, [
            { required: true, message: `${triggleType.text}${formItem.label}`, trigger: triggleType.trigger },
          ]);
        });
      },
      // 初始化筛选条件
      initQueryParam(exclude) {
        this.formList.forEach((formItem) => {
          if (exclude && exclude.includes(formItem.model)) {
            return
          }
          const defaultValue = formItem.default || '';
          if (formItem.type === 'date') {
            ['startTime', 'endTime'].forEach((key, index) => {
              this.$set(this.queryParam, formItem[key] || key,
                !defaultValue || !Array.isArray(defaultValue) ? defaultValue : defaultValue[index]
              );
            });
            this.$set(this.date, formItem.model, defaultValue ? defaultValue : formItem.renderType === 'daterange' ? [] : '');
          } else if (formItem.type === 'cascader') {
            this.$set(this.queryParam, formItem.model, defaultValue);
            this.$set(this.cascader, formItem.model, defaultValue);
          } else if(formItem.type === 'select') {
            this.$set(this.queryParam, formItem.model, defaultValue);
            if(formItem.pageKey){
              this.$set(this.selectPagination, formItem.model, {current: 1, size: formItem.pageSize || SELECT_PAGE_SIZE, pages: 0});
            }
          } else {
            this.$set(this.queryParam, formItem.model, defaultValue);
          }
        });
      },
      // 监听date变化
      watchDateChange() {
        this.dateFormList.forEach((dateForm) => {
          const option = {
            handler(value) {
              if (dateForm.renderType === 'date') {
                this.$set(this.queryParam, dateForm.model, value);
              }else if(['daterange','datetimerange'].includes(dateForm.renderType)){
                this.$set(this.queryParam, dateForm['startTime'], value[0]);
                this.$set(this.queryParam, dateForm['endTime'], value[1]);
              }else{
                var range = formatRangeDateByType(value, dateForm.renderType);
                if(dateForm['resMakeupTime']){
                  range = formatRangeMakeupTime(range);
                }
                this.$set(this.queryParam, dateForm['startTime'], range[0]);
                this.$set(this.queryParam, dateForm['endTime'], range[1]);
              }
            },
            deep: true,
            immediate: true,
          };
          this.$watch(`date.${dateForm.model}`, option);
        });
      },
      // 监听下拉框、级联框、单多选数据，从接口中获取
      watchSelectRequestChange() {
        var filterRequestForm = function () {
          const list = this.sortFormList.filter(form => {
            if (FORM_REQUEST_DATA_ITEM.includes(form.type)) {
              if (form.url) {
                this.$set(this.selectDataList, form.model, []);
              }
              if (form.data) {
                this.selectDataList[form.model] = form.filter ? form.filter(form.data) : form.data;
              } else {
                form.param = {};
                if (form['extraParam']) {
                  // 示例extraParam参数['name="test"','type=1']
                  form['extraParam'].forEach((query) => {
                    if (typeof query === 'string') {
                      if (query.indexOf('=') > -1) {
                        const qk = query.split('=');
                        form.param[qk[0]] = qk[1] || form.default || '';
                      } else {
                        form.param[query] = this.queryParam[query] || form.default || '';
                      }
                    } else {
                      Object.assign(form.param, query);
                    }
                  });
                }
                //关键字搜索
                if (form.keyword) {
                  form.param[form.keyword] = '';
                }
                if (form.pageKey) {
                  form.param[form.pageKey.current] = this.selectPagination[form.model].current;
                  form.param[form.pageKey.size] = this.selectPagination[form.model].size;
                  this.$set(form, 'selectLoading', false);
                  //this.$set(form, 'selectFinished', false);
                }
              }
              return Boolean(form.url);
            }
          });
          return list;
        };
        const option = {
          handler() {
            this.selectRequestFormList = filterRequestForm.call(this);
            if(this.selectRequestFormList.length){
              this.batchSelectList();
            }
          },
          deep: true,
          immediate: true,
        };
        this.$watch(`sortFormList`, option);
      },
      // 监听下拉框、级联框、单多选数据，从vuex变化读取
      watchSelectStoreChange() {
        this.selectFormList.forEach((selectForm) => {
          if (selectForm['asyncDataKey']) {
            const option = {
              handler(value) {
                console.log(`listPage控件监听异步数据源：`, value);
                this.selectDataList[selectForm.model] = value;
              },
              deep: true,
              immediate: true,
            };
            this.$watch(selectForm['asyncDataKey'], option);
          }
        })
      },
      // 获取真实formItem
      getRealFormItem(model) {
        return this.sortFormList.find(v => v.model === model);
      },
      // 批量请求数据并处理
      batchSelectList(model) {
        let formListConfigIndex = [];
        function setLoad(val) {
          if (model) {
            const formRecord = this.selectRequestFormList.filter(v => v.model === model)[0];
            if (formRecord) {
              formRecord.selectLoading = val;
            }
          }
        }
        setLoad.call(this, true);
        let queryList = this.selectRequestFormList
          .filter(v => {
            //v.munualLoad ? !model ? true : v.model === model : true
            if (!model) {
              return !v.munualLoad && !v.disableAutoLoad
            } else {
              return v.model === model
            }
          })
          .map((item) => {
            const index = this.selectRequestFormList.findIndex(item => item.model === model);
            formListConfigIndex.push(index);
            return item.ajaxType === 'post' ?
              postAction(transParmasBypostToGet(item.url, item.param), item.param, item.headers) : getAction(item.url, item.param, item.headers);
          });
        if (!queryList.length) return;

        let allPromise = Promise.all(queryList.map((promise) => promise.catch((e) => {
          console.log("错误信息" + e)
        })));

        allPromise.then((selectList) => {
          selectList.forEach((res, index) => {
            let formItem = formListConfigIndex[index];
            setLoad.call(this, false);
            if (res) {
              this.handleSelectData(res, model ? formItem : index);
            }
          });
        });
      },
      // 处理下拉列表数据
      handleSelectData(data, index) {
        const formItem = typeof index === 'number' ? this.selectRequestFormList[index] : index;
        let result = getObjProperty(data, formItem.dataPath);
        if (formItem['resFormat'] && typeof formItem['resFormat'] === 'function') {
          result = formItem['resFormat'](result);
        }
        result = result ? result.filter((i) => i && i !== 'null') : [];
        if (result.length) {
          result = result.map((item) => {
            if (typeof result[0] !== 'object') {
              return {key: item, value: item};
            } else {
              let child = null;
              return {
                ...item,
                key: item[formItem.key || 'label'],
                value: item[formItem.value || 'value'],
                child,
              };
            }
          });
        }
        if (formItem.type === 'cascader') {
          processLastChildrens(result);
        }
        if (formItem.pageKey) {
          this.selectPagination[formItem.model].pages = Math.ceil(formItem.param.size * formItem.param.current / getObjProperty(data, formItem.totalPath));
          if (formItem.param[formItem.pageKey.current] === 1) {
            this.selectDataList[formItem.model] = result;
          } else {
            this.selectDataList[formItem.model] = this.selectDataList[formItem.model].concat(result);
          }
        } else {
          this.selectDataList[formItem.model] = result;
        }
      },
      // 重载第一页
      firstPageReloadData() {
        this.elPaginationConfig[PAGE_CURRENT] = 1;
        this._getDataList();
      },
      // 刷新页面
      refreshPage() {
        this.elPaginationConfig[PAGE_CURRENT] = 1;
        this.selectedRows = [];
        this.currentRow = {};
        this.postSelectRows();
        this.postClickRow();
        this.initQueryParam();
        this.$nextTick(() => {
          this._getDataList();
        });
      },
      // 查询列表数据
      searchQuery() {
        console.log(this.queryParam)
        this.$refs['esForm'].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
        //this.firstPageReloadData();
      },
      // 重置查询条件
      searchReset() {
        if (this.handleResetPage) {
          this.handleResetPage(this);
        }
        this.cascaderKey++; // add: fix bug level of null
        this.refreshPage();
      },
      selectRemoteMethod(query, formItem) {
        if (!formItem.param) {
          formItem.param = {};
        }
        if (formItem.keyword) {
          formItem.param[formItem.keyword] = query;
        }
        if (formItem.page) {
          formItem.param[formItem.page.current] = 1;
        }
        this.selectDataList[formItem.model] = [];
        if (!query && formItem.disableAutoLoad) {
          return
        }
        this.batchSelectList(formItem.model);
      },
      selectLoadMoreList(formItem) {
        // 防抖处理
        let timeout = null;
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          if (!formItem.param) return;
          if (formItem.param.current >= this.selectPagination[formItem.model].pages) return;
          formItem.param[formItem.pageKey.current]++;
          this.batchSelectList(formItem.model);
        }, 300)
      },
      selectVisibleChange(v, formItem) {
        if (!v) {
          if (formItem.param && !formItem.param[formItem.model]) {
            formItem.param[formItem.model] = "";
            // 下拉框隐藏时候置空数据
            // this.selectDataList[formItem.model] = [];
          }
        } else {
          if (formItem.click && formItem.click) {
            formItem.click.call(formItem, this);
          }
        }
      },
      selectClearList(formItem) {
        if (formItem.param) {
          formItem.param[formItem.model] = "";
          formItem.param[formItem.keyword] = "";
          if (formItem.page) {
            formItem.param[formItem.page.current] = 1;
          }
        }
        if (formItem.url) {
          if (formItem.disableAutoLoad) {
            this.selectDataList[formItem.model] = [];
            return
          }
          this.selectDataList[formItem.model] = [];
          this.batchSelectList(formItem.model);
        }
      },
      selectBlurList(formItem) {
        // 针对远程搜索下拉框，关键字搜索结果是空，重新查询接口
        if (formItem.url && !formItem.munualLoad && !this.selectDataList[formItem.model].length) {
          formItem.param[formItem.model] = "";
          formItem.param[formItem.keyword] = "";
          this.selectClearList(formItem)
        }
      },
      // 下拉列表选项发生变化
      selectChange(values, formItem) {
        this.$emit('handlerSelectChange', values, formItem);
        if (formItem.multiple) {
          const model = formItem.model;
          let result = [...values];
          // 判断点击的是否是空串
          const currentRow = result[result.length - 1];
          result = result.filter((value) => {
            if (currentRow) {
              return value;
            } else {
              return !value;
            }
          });
          if (
            !values.length ||
            (values.length === this.selectDataList[model].length && values.every((value) => value))
          ) {
            result = [''];
          }
          this.$set(this.queryParam, model, result);
        }
        // 联动修改
        if (formItem.relModel) {
          const relFormItems = this.formList.filter(v => typeof formItem.relModel === 'boolean' || formItem.relModel.includes(v.model));
          if (!relFormItems.length) return;
          formItem.relAction && formItem.relAction.call(relFormItems[0], values, this);
        }
        if (formItem.change) {
          formItem.change.call(this, values);
        }
      },
      // 级联下拉列表选项发生变化
      cascaderChange(values, formItem) {
        if (values.length !== 0) {
          this.queryParam[formItem.model] = values[values.length - 1];
        } else {
          this.queryParam[formItem.model] = '';
        }
        this.$refs['cascader_' + formItem.model][0].dropDownVisible = false;
      },
      // 重载数据
      reloadData() {
        this._getDataList();
      },
      // table表格 获取表格数据
      async _getDataList() {
        this.tableLoading = true;
        const {PAGE_CURRENT: current, PAGE_SIZE: size} = this.elPaginationConfig;
        const action = this.esTableApi.type === 'get' ? getActionTimeout : postActionTimeout;
        const notQueryParamList = this.formList
          .filter((form) => form.notQueryParam)
          .map((form) => form.model);
        const showAllList = this.formList.filter((form) => form.showAll).map((show) => show.model);
        let queryParam = {...this.esTableApi.query};
        notQueryParamList.forEach((not) => {
          if (queryParam.hasOwnProperty(not)) {
            delete queryParam[not];
          }
        });
        showAllList.forEach((showAll) => {
          if (queryParam.hasOwnProperty(showAll) && queryParam[showAll] === '') {
            queryParam[showAll] = this.selectDataList[showAll].map((select) => select.value);
          }
        });
        Object.keys(queryParam).forEach((key) => {
          if (this.selectDataList[key] && Array.isArray(queryParam[key])) {
            queryParam[key] = queryParam[key].join();
          }
        });
        if (this.handleQueryParam) {
          queryParam = this.handleQueryParam(queryParam, this);
        }
        // 先判断必填项是否为空
        let isRequiredFlag = false;
        this.formList.every((item) => {
          if (item.isRequired) {
            if (!queryParam[item.model]) {
              this.tableLoading = false;
              isRequiredFlag = true;
              this.$message.warning(item.label + "不能为空")
              return false;
            }
          } else {
            return true;
          }
        })
        if (isRequiredFlag) {
          return
        }
        let tableAction =
          this.esTableApi instanceof Function
            ? this.esTableApi({
              ...queryParam,
              ...this.additionQuery,
              [this.esTableApi.pageKey.current]: current,
              [this.esTableApi.pageKey.size]: size,
            })
            : action(`${this.esTableApi.url}`, {
              ...queryParam,
              ...this.additionQuery,
              [this.esTableApi.pageKey.current]: current,
              [this.esTableApi.pageKey.size]: size,
            }, this.esTableApi.headers);
        this.$emit('getQueryParams', queryParam);
        tableAction
          .then((result) => {
            console.log(result)
            /*if (res.code !== 0) {
              this.dataSource = [];
              this.pagination.total = 0;
              this.$message.error(res.message);
              return;
            }*/
            var source = getObjProperty(result, this.esTableApi.dataPath);

            let dataSource = source.map((v, i) => {
              v['_index'] = i;
              v['_rowIndex'] = i + 1;
              return v
            }) || [];

            if (this.prepareHandleSource) {
              dataSource = this.prepareHandleSource(dataSource);
            }

            this.elPaginationConfig.total =  getObjProperty(result, this.esTableApi.totalPath) || 0;
            if (dataSource.length) {
              // 处理回显
              this.reviewTable();
            }
            this.elTableConfig.data = [...dataSource];
            this.$emit('getDataSource', dataSource);
          })
          .catch(() => {
            this.elTableConfig.data = [];
          })
          .finally(() => {
            this.tableLoading = false;
          });
      },
      // 表格字段回显
      reviewTable() {
        this.$nextTick(() => {
          const dataSource = [...this.elTableConfig.data];
          dataSource.forEach((data) => {
            Object.keys(this.selectDataList).forEach((item) => {
              if (data.hasOwnProperty(item)) {
                const objData = this.selectDataList[item].find((item1) => item1.value === data[item]);
                if (objData) {
                  data[`${item}Name`] = objData.key;
                }
              }
            });
          });
          this.elTableConfig.data = [...dataSource];
        });
      },
      // 自定义当前选中的行背景样式
      setRowClassName(record) {
        if (record[this.rowKey] === this.currentRow[this.rowKey] && !this.showSelection) {
          return 'select';
        } else {
          return '';
        }
      },
      // 行点击事件
      rowClick(record) {
        return {
          on: {
            click: () => {
              if (record[this.rowKey] != this.currentRow[this.rowKey] && !this.showSelection) {
                this.currentRow = record;
                this.postClickRow();
              }
            },
          },
        };
      },
      // 复选框勾选事件
      onRowSelectChange(selectedRows) {
        this.selectedRows = selectedRows;
        this.postSelectRows();
      },
      // 翻页
      handleTablePageChange(page) {
        this.elPaginationConfig[PAGE_CURRENT] = page;
        this._getDataList();
      },
      handleTableSizeChange(size) {
        this.elPaginationConfig[PAGE_SIZE] = size;
        this._getDataList();
      },
      // 当前选择的项 -> 多选
      postSelectRows() {
        this.$emit('getSelectRows', this.selectedRows);
      },
      // 当前选择的项 -> 适合单选
      postClickRow() {
        this.$emit('getClickRow', this.currentRow);
      },
      //重新更新配置
      refreshConfig(config, exclude = [], reload = false) {
        this.tableLoading = true;
        if (config.columns) {
          this.$emit('update:columns', config.columns);
        }
        if (config.tools) {
          this.$emit('update:formList', config.tools);
        }
        this.$nextTick(() => {
          this.tableLoading = false;
          this.initQueryParam(exclude);
          if (reload) {
            this.reloadData();
          }
        });
      },
      // 导出
      exportTable() {
        const notQueryParamList = this.formList
          .filter((form) => form.notQueryParam)
          .map((form) => form.model);
        const showAllList = this.formList.filter((form) => form.showAll).map((show) => show.model);
        let queryParam = {...this.queryParam};
        if (this.handleQueryParam) {
          queryParam = this.handleQueryParam(queryParam, this);
        }
        // 过滤掉undefined
        for (let key in queryParam) {
          if (queryParam[key] === undefined) {
            delete queryParam[key];
          }
        }
        notQueryParamList.forEach((not) => {
          if (queryParam.hasOwnProperty(not)) {
            delete queryParam[not];
          }
        });
        showAllList.forEach((showAll) => {
          if (queryParam.hasOwnProperty(showAll) && queryParam[showAll] === '') {
            queryParam[showAll] = this.selectDataList[showAll].map((select) => select.value);
          }
        });
        Object.keys(queryParam).forEach((key) => {
          if (this.selectDataList[key] && Array.isArray(queryParam[key])) {
            queryParam[key] = queryParam[key].join();
          }
        });
        Object.assign(queryParam, this.additionQuery);
        // 先判断必填项是否为空
        let isRequiredFlag = false;
        this.formList.every((item) => {
          if (item.isRequired) {
            if (!queryParam[item.model]) {
              this.tableLoading = false;
              this.$message.warning(item.label + "不能为空")
              isRequiredFlag = true;
              return false;
            }
          } else {
            return true;
          }
        })
        if (isRequiredFlag) {
          return
        }
        this.handleExportXls(this.exportApi, queryParam, this.exportFileName);
      },
      // 导出请求
      handleExportXls(url, param, fileName) {
        this.tableLoading = true;
        if (this.exportMsgCenter) {
          try {
            /*downloadCenter(url, param, fileName).then(res => {
              if (!res) return;
              if (res.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: res.data.msg
                });
              } else {
                this.$message.error(res.data.msg);
              }
            }).finally(() => {
              this.tableLoading = false;
            });*/
          } catch (e) {
            this.tableLoading = false;
          }
          return
        }
        //手动浏览器下载
        downFileTimeout(url, param).then((data) => {
          // 集中消息-手动下载
          if (!data) {
            this.$message.warning('文件下载失败');
            return;
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(
              new Blob([data], {type: 'application/vnd.ms-excel'}),
              fileName + '.xls',
            );
          } else {
            let url = window.URL.createObjectURL(
              new Blob([data], {type: 'application/vnd.ms-excel'}),
            );
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', fileName + '.xls');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
          }
        }).finally(() => {
          this.tableLoading = false;
        });
      },
    },
  };
</script>
<style lang="css" scoped>
  .form-table-pagination{
    text-align: center;
    margin-top: 15px;
  }
</style>
